import { render, staticRenderFns } from "./MatchResultList.vue?vue&type=template&id=2d62d380&scoped=true&"
import script from "./MatchResultList.vue?vue&type=script&lang=js&"
export * from "./MatchResultList.vue?vue&type=script&lang=js&"
import style0 from "./MatchResultList.vue?vue&type=style&index=0&id=2d62d380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62d380",
  null
  
)

export default component.exports